const collection = {
    loading: true,
    data: [],
    errors: [],
    meta: {},
}
const model = {
    loading: true,
    data: {},
    errors: [],
}


module.exports = {collection, model}
